<obg-m-overlay-spinner *ngIf="isLoading$ | async"></obg-m-overlay-spinner>
<ng-container *ngIf="currentStep$ | async as currentStep" [ngSwitch]="currentStep">
	<ng-container *ngSwitchCase="stepLogin">
		<h1 class="login-title">{{ 'general.sign-in' | translate }}</h1>
		<obg-m-login-container
			[disallowedRedirection]="disallowedRedirection"
			[disallowLogin]="disallowLogin"
			[hideSgaLogin]="hideSgaLogin$ | async"
			[hideEmailPasswordLoginForDga]="hideEmailPasswordLoginForDga$ | async"
			(busy)="isLoading$.next($event)"
			#loginContainer
			allLinksExternal
			hideFooter
		>
		</obg-m-login-container>
	</ng-container>
	<obg-m-common-poker-login-verification
		*ngIf="currentStep === stepJurisdictionMismatch || currentStep === stepPokerMigration || currentStep === stepProfileCompleteness || currentStep === stepCountryRestriction"
		(action)="endSession()"
		[customerJurisdiction]="customerJurisdiction"
		[currentStep]="currentStep"
		[authToken]="authToken"
		[pegaJurisdiction]="pegaJurisdiction"
	></obg-m-common-poker-login-verification>
	<div class="obg-m-poker-login-sga-verification" *ngSwitchCase="stepSgaVerification">
		<h1 class="login-title">{{ 'sga-verification-transaction.label' | translate }}</h1>
		<obg-m-sga-login-container mode="verification" (busy)="isLoading$.next($event)"></obg-m-sga-login-container>
	</div>
	<obg-m-updated-terms-and-conditions-container
		allLinksExternal
		*ngSwitchCase="stepTC"
		(busy)="isLoading$.next($event)"
	></obg-m-updated-terms-and-conditions-container>
	<div class="obg-m-common-poker-login-sga-summary" *ngSwitchCase="stepSgaMessage">
		<img obgImageContent="general.brand-logo.inverse" />
		<obg-m-sga-login-notice [data]="sgaMessages$ | async"></obg-m-sga-login-notice>
		<button mat-flat-button color="accent" (click)="onSgaDismiss()">{{ 'general.close' | translate }}</button>
	</div>
</ng-container>
<obg-compact-footer [showLicenseLogo]="showLicenseLogo$ | async"></obg-compact-footer>
